module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAAHtJREFUGBljYEAD////FwLizUB8Dk0KlQtUoAfEd4EYDFBlkXhA2Qgg/gpRBiGRpCFMoDAzEPcgK8LFZgBKrMcliS7OBDRfCMM6XAJA3ZxAPB/dFGx8uBlAyTQg/oGsCC6JjQFUaArED2EasKlBEQMqFAZiUKScR5EAcgAMSNoehQPSWwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left-icon.png
// module id = ELPR
// module chunks = 17